export default __webpack_public_path__ + "static/media/drought-modal-img.7f132b67.svg";